import React from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  Tooltip,
  IconButton,
  styled,
  FormHelperText,
  Grid
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Notify from "../../../../Notify";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { getData, putData, getCodeArg } from "../../../../../services/library";
import { UrlApi } from "../../../../../services/apirest";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import AltaDireccionEnv from "../direcciones/AltaDireccionEnv";

const StyledBox = ({ label, value, name }) => (
    <>
      <Typography variant="subtitle2" color="textSecondary" sx={{ marginBottom: "-5px", marginTop: "-4px" }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ marginBottom: "-5px", marginTop: "-5px" }}>
        {value || "No registrado"}
      </Typography>
    </>
  );

function PedidoCliente(props) {
    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
      };
      const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
      });
    
      const [datosPedido, setdatosPedido] = useState({
        observaciones: "",
        fecha_para: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
      });
    
      const [agregarCoordenadas, setAgregarCoordenadas] = useState(false)
      const [abrirCoordenadas, setAbrirCoordenadas] = useState(false)
      const [tabla, setTabla] = useState(true)
      const [alta, setAlta] = useState(false)
      const [nuevaDireccion, setNuevaDireccion] = useState(false)
      const [uuidPedido, setUuidPedido] = useState(uuidv4);
      const [clientes, setClientes] = useState(null);
      const [clienteSeleccionado, setClienteSeleccionado] = useState("");
      const [direcciones, setDirecciones] = useState(null);
      const [direccionSeleccionada, setdireccionSeleccionada] = useState("");
      const [productoSeleccionado, setProductoSeleccionado] = useState("");
      const [productosPredeterminados, setproductosPredeterminados] = useState();
      const [productos, setProductos] = useState();
      const [buscando, setBuscando] = useState(false);
      const [cliente, setcliente] = useState(props.cliente)

      useEffect(() => {
        getData("/envasado_clientes/activos", setClientes);
        getData("/productos/envasados", setProductos);
      }, [tabla]);
    
      useEffect(() => {
        setdireccionSeleccionada("");
        getData(
          "/envasado_direcciones_entrega/cli/" + props.cliente.id,
          setDirecciones
        );
        setBuscando(false);
        setAgregarCoordenadas(false)
      }, [tabla]);
    
      const obtenerProductosPre = () => {
        fetch(
          UrlApi +
            "/envasado_producto_predeterminado/xdir/" +
            direccionSeleccionada.id
        )
          .then((data) => data.json())
          .then((data) => {
            setproductosPredeterminados(data);
            let nuevasLineas = data.map((producto) => ({
              uuid_pedido: uuidPedido,
              producto: producto.id_producto,
              cantidad: 1,
              especificaciones: "",
            }));
            if (nuevasLineas.length === 0) {
              nuevasLineas = [
                {
                  uuid_pedido: uuidPedido,
                  producto: null,
                  cantidad: 1,
                  especificaciones: "",
                },
              ];
            }
            setDatosRenglon(nuevasLineas);
          });
      };
        
      useEffect(() => {
        if (Object.keys(direccionSeleccionada).length !== 0) {
          obtenerProductosPre();
        }
      }, [direccionSeleccionada]);
    
      const [datosRenglon, setDatosRenglon] = useState([
      ]);
      useEffect(() => {
        setDatosRenglon([])
      }, [clienteSeleccionado, direccionSeleccionada])
      
    
      const agregarLinea = () => {
        const nuevaLinea = {
          uuid_pedido: uuidPedido,
          producto: null,
          cantidad: 1,
          especificaciones: "",
        };
        setDatosRenglon((prevLineas) => [...prevLineas, nuevaLinea]);
      };
    
      const handleProductoChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].producto = value ? value.idproducto : null;
        setDatosRenglon(nuevasLineas);
      };
    
      const handleCantidadChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].cantidad = value;
        setDatosRenglon(nuevasLineas);
      };
    
      const handleEspecificacionesChange = (index, value) => {
        const nuevasLineas = [...datosRenglon];
        nuevasLineas[index].especificaciones = value;
        setDatosRenglon(nuevasLineas);
      };
    
      const deshacerAlmacenar = (index) => {
        const nuevasLineas = datosRenglon.filter((_, i) => i !== index);
        setDatosRenglon(nuevasLineas);
      };
    
      const getProductoById = (id) => {
        return productos ? productos.find((producto) => producto.idproducto === id) : null;
      };
    
      const guardarPedido = async (e) => {
        await fetch(UrlApi + "/envasado_pedidos", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            tipo: 1,
            id_direccion: direccionSeleccionada.id,
            fecha_para: datosPedido.fecha_para,
            observaciones: datosPedido.observaciones,
            uuid_pedido: uuidPedido,
            estado: 245,
            usuario: localStorage.getItem("user"),
          }),
        })
          .then((res) => {
            if (!res.err) {
              console.log("Guardado");
            } else {
              console.log("Error");
            }
          })
          .catch((err) => {
            console.log(err.message);
          });
    
        for (let i = 0; i < datosRenglon.length; i++) {
          const element = datosRenglon[i];
          await fetch(UrlApi + "/envasado_pedidos_renglon", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              uuid_pedido: uuidPedido,
              producto: datosRenglon[i].producto,
              cantidad: datosRenglon[i].cantidad,
              especificaciones: datosRenglon[i].especificaciones,
              usuario: localStorage.getItem("user"),
            }),
          })
            .then((res) => {
              if (!res.err) {
                // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
                // setUpdate(true);
                console.log("Guardado");
              } else {
                console.log("Error");
              }
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
        handleClose();
      };
    
      const handleClose = () => {
        props.setOpen(false);
        props.actualizar()
      };
    
      const almacenar = (e) => {
        setdatosPedido({
          ...datosPedido,
          [e.target.name]: e.target.value,
        });
      };
    
      const handleClickNuevaDireccion = () => {
        setNuevaDireccion(true); //pongo alta en true para q muestre el componente Addcliente
        setTabla(false); //tabla en false para que no se muestre la tabla
      };
    
      const handleCloseDireccion = () => {
        setNuevaDireccion(false);
        setTabla(true);
      };
    
      const handleClickAgregarCoordenadas = () => {
        setAbrirCoordenadas(true); //pongo alta en true para q muestre el componente Addcliente
        setTabla(false); //tabla en false para que no se muestre la tabla
      };
    
      useEffect(() => {
        if (direccionSeleccionada && (direccionSeleccionada.latitud === null || direccionSeleccionada.longitud === null)) {
          setAgregarCoordenadas(true)
        }else{
          setAgregarCoordenadas(false)
        }
      }, [direccionSeleccionada, tabla])
      
    
      return (
        <div>
          {tabla?(
          <Dialog
            fullWidth
            open={props.open}
            onClose={() => props.setOpen(false)}
            maxWidth="xl"
          >
            {notificacion && notificacion.open ? (
              <Notify
                mensaje={notificacion.mensaje}
                open={notificacion.open}
                color={notificacion.color}
                handleClose={() => {
                  props.setOpen(false);
                  props.actualizar();
                }}
                severity={notificacion.severity}
              />
            ) : null}
            <Box justifyContent="center" backgroundColor="#1F618D">
              <DialogTitle>
                <Typography fontSize={20} align="center" color="#ffffff">
                  Nuevo Pedido
                </Typography>
              </DialogTitle>
            </Box>
            <form>
              <DialogContent>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                        <TextField
                          placeholder="Tipee para buscar..."
                          style={style}
                          size="small"
                          label="Cliente"
                          value={props.cliente.razon_social}
                          focused
                        />
                  </Grid>
                  <Grid item xs={5.5}>
                    {buscando === true ? (
                      <TextField
                        disabled
                        focused
                        fullWidth
                        label="Buscando Direcciones..."
                      />
                    ) : (
                      <>
                      <Autocomplete
                        disabled={!direcciones}
                        required
                        disableClearable
                        id="direccion"
                        style={style}
                        size="small"
                        noOptionsText={"Direccion INEXISTENTE"}
                        options={direcciones}
                        autoHighlight
                        getOptionLabel={(direccion) => direccion.direccion_entrega}
                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                        value={direccionSeleccionada || null}
                        defaultValue={direccionSeleccionada || null}
                        onChange={(event, value) => {
                          setdireccionSeleccionada(value);
                        }}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            key={option.id}
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.direccion_entrega}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            placeholder="Tipee para buscar..."
                            {...params}
                            label="Direccion"
                            focused
                            inputProps={{
                              ...params.inputProps,
                            }}
                          />
                        )}
                      />
                      {agregarCoordenadas === true?
                      <FormHelperText sx={{ bgcolor: "lemonchiffon", color: "#5D6D7E" }}>
                        La Dirección de Entrega no tiene coordenadas, para agregarlas pulse "Agregar Coordenadas" 
                      </FormHelperText>
                      :null}
                      </>
                    )}
                  </Grid>
                  {agregarCoordenadas ? (
                    <Grid item xs={0.5}>
                      <Tooltip
                        title={`Agregar coordenadas`}
                      >
                        <IconButton
                          color="secondary"
                          onClick={() => {
                            handleClickAgregarCoordenadas();
                          }}
                        >
                          <AddLocationAltIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  ) : null}
                    <Grid item xs={0.5}>
                      <Tooltip
                        title={`Agregar direccion a ${props.cliente.razon_social}`}
                      >
                        <IconButton
                          color="primary"
                          onClick={() => {
                            handleClickNuevaDireccion();
                          }}
                        >
                          <AddCircleIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
    
                  <Grid item xs={12} mr={3}>
                    {direccionSeleccionada !== "" ? (
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          padding: "10px",
                          // margin: '5px 0',
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          backgroundColor: "#f9f9f9",
                          width: "100%",
                        }}
                      >
                        <Grid container spacing={2}>
                          <Grid item xs={2}>
                            <StyledBox
                              label="CUIT/DNI"
                              value={props.cliente.cuit}
                              name="cuit"
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <StyledBox
                              label="Observaciones de Cliente"
                              value={props.cliente.observaciones}
                              name="observaciones"
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <StyledBox
                              label="Envase 10 KG"
                              value={props.cliente.envase_10_kg}
                              name="envase_10_kg"
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <StyledBox
                              label="Envase 15 KG"
                              value={props.cliente.envase_15_kg}
                              name="envase_15_kg"
                            />
                          </Grid>
                          <Grid item xs={2}>
                            <StyledBox
                              label="Envase 45 KG"
                              value={props.cliente.envase_45_kg}
                              name="envase_45_kg"
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <StyledBox
                              label="MAILS"
                              value={props.cliente.mails}
                              name="mails"
                            />
                          </Grid>
                          {props.cliente.telefono_1 && (
                            <Grid item xs={2}>
                              <StyledBox
                                label="Telefono"
                                value={props.cliente.telefono_1}
                                name="telefono_1"
                              />
                            </Grid>
                          )}
                          {props.cliente.telefono_2 && (
                            <Grid item xs={2}>
                              <StyledBox
                                label="Telefono"
                                value={props.cliente.telefono_2}
                                name="telefono_2"
                              />
                            </Grid>
                          )}
                          {props.cliente.telefono_3 && (
                            <Grid item xs={2}>
                              <StyledBox
                                label="Telefono"
                                value={props.cliente.telefono_3}
                                name="telefono_3"
                              />
                            </Grid>
                          )}
                          {direccionSeleccionada.observaciones && (
                            <Grid item xs={4}>
                            <StyledBox
                              label="Observacion de Dirección"
                              value={direccionSeleccionada.observaciones}
                              name="observaciones_dir"
                            />
                          </Grid>
                          )}
                        </Grid>
                      </Box>
                    ) : null}
                  </Grid>
    
                  <Grid item xs={12} mr={3}>
                    {direccionSeleccionada ? (
                      <Box
                        sx={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          padding: "10px",
                          // margin: '5px 0',
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          backgroundColor: "#f9f9f9",
                          width: "100%",
                        }}
                      >
                        <Grid container spacing={1}>
                        <Grid item xs={4}>
                          <TextField
                            fullWidth={true}
                            focused
                            size="small"
                            type="datetime-local"
                            required
                            placeholder="Fecha "
                            name="fecha_para"
                            label="Fecha de Pedido"
                            variant="outlined"
                            value={moment(datosPedido.fecha_para).format("YYYY-MM-DDTHH:mm")}
                            onChange={almacenar}
                          />
                        </Grid>
                        <Grid item xs={8}>
                          <TextField
                            label="Observaciones"
                            name="observaciones"
                            size="small"
                            focused
                            required
                            fullWidth
                            autoComplete="off"
                            value={datosPedido.observaciones}
                            onChange={almacenar}
                          />
                        </Grid>
                        </Grid>
                      </Box>
                    ) : null}
                    {direccionSeleccionada ? (
                    <Box
                      sx={{
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        padding: "10px",
                        margin: '5px 0',
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                        backgroundColor: "#f9f9f9",
                        width: "100%",
                      }}
                    >
                      {datosRenglon
                        ? datosRenglon.map((linea, index) => (
                            <div
                              key={index}
                              style={{
                                paddingBottom: "4px",
                                paddingLeft: "3px",
                                paddingTop: "10px",
                              }}
                            >
                              <Grid container spacing={2}>
                                <Grid item xs={5}>
                                  {productos && (
                                    <Autocomplete
                                      disabled={!productos}
                                      disableClearable
                                      size="small"
                                      required
                                      noOptionsText={"Producto INEXISTENTE"}
                                      options={productos}
                                      autoHighlight
                                      getOptionLabel={(producto) =>
                                        producto.codigoproducto + "-" + producto.nombre 
                                      }
                                      value={getProductoById(linea.producto)}
                                      onChange={(event, value) => {
                                        handleProductoChange(index, value);
                                        setProductoSeleccionado(value);
                                      }}
                                      renderOption={(props, option) => (
                                        <Box
                                          component="li"
                                          key={option.id}
                                          sx={{
                                            "& > img": { mr: 2, flexShrink: 0 },
                                          }}
                                          {...props}
                                        >
                                          {option.codigoproducto} - {option.nombre} 
                                        </Box>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          inputProps={{
                                            ...params.inputProps,
                                          }}
                                          focused
                                          size="small"
                                          placeholder="Tipee para buscar..."
                                          label="Producto"
                                        />
                                      )}
                                    />
                                  )}
                                </Grid>
    
                                <Grid item xs={1}>
                                  <TextField
                                    label="Cantidad"
                                    name="cantidad"
                                    size="small"
                                    type="number"
                                    focused
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    value={linea.cantidad || ""}
                                    onChange={(e) =>
                                      handleCantidadChange(index, e.target.value)
                                    }
                                  />
                                </Grid>
                                <Grid item xs={5}>
                                  <TextField
                                    label="Especificaciones"
                                    name="especificaciones"
                                    size="small"
                                    focused
                                    required
                                    fullWidth
                                    autoComplete="off"
                                    value={linea.especificaciones || ""}
                                    onChange={(e) =>
                                      handleEspecificacionesChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                  />
                                </Grid>
                                <Grid
                                  item
                                  xs={1}
                                  fullWidth
                                >
                                  {" "}
                                  {/* Columna para los iconos */}
                                  {index > 0 && (
                                  <Tooltip title="Eliminar línea">
                                    <IconButton
                                      variant="outlined"
                                      color="error"
                                      onClick={() => deshacerAlmacenar(index)}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </Tooltip>)}
                                  {index === datosRenglon.length - 1 && (
                                    <Tooltip title="Agregar línea">
                                      <IconButton
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                          agregarLinea();
                                        }}
                                      >
                                        <AddCircleOutline />
                                      </IconButton>
                                    </Tooltip>
                                  )}
                                </Grid>
                              </Grid>
                            </div>
                          ))
                        : null}
                    </Box>)
                    :null}
                  </Grid>
                </Grid>
    
                <Grid
                  container
                  direction="row"
                  justifyContent="space-between"
                  mt={1}
                >
                  <Grid item>
                    <Button
                      color="error"
                      variant="outlined"
                      onClick={() => props.setOpen(false)}
                      style={{ backgroundColor: "#fff" }}
                    >
                      Volver
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      color="success"
                      variant="contained"
                      onClick={guardarPedido}
                    >
                      Guardar
                    </Button>
                  </Grid>
                </Grid>
              </DialogContent>
            </form>
          </Dialog>
          ):null}
    
          {nuevaDireccion ? (
            <AltaDireccionEnv
              open={nuevaDireccion}
              setOpen={setNuevaDireccion}
              cliente={cliente}
              onClose={handleCloseDireccion}
            />
          ) : null}
        </div>
      );
}

export default PedidoCliente